export const PAYMENT_STATUS = {
  FAILED: "failed",
  PENDING: "pending",
  SUCCESS: "success",
  MONEY_DEDUCTED: "deducted",
};

/**
 * MASTER_PAYMENT_STATUS is used to show fallback messages on bottomsheet
 * for paymentFailure flow
 */
export const MASTER_PAYMENT_STATUS = {
  FAILURE: "FAILURE",
  PENDING: "PENDING",
  SUCCESS: "SUCCESS",
  USER_DROPPED: "USER_DROPPED",
};

export const PAYMENT_ERROR_MESSAGE = {
  FAILED: "PAYMENT FAILED",
  SERVER_ERROR: "SERVER ERROR",
  SOMETHING_WENT_WRONG: "Something went wrong",
  SOMETHING_WENT_WRONG_WITH_WALLET: "Something wrong with wallet",
  ERROR: "ERROR",
  WALLET_PAYMENT_FAILED: "Sorry, your transaction has failed. In case your money is deducted, we will refund the amount to the source account.",
};

export const PAYMENT_STATUS_CODE = {
  TRANSACTION_FAILED: "transaction_failed",
  PAYMENT_ERROR: "payment_error",
};
